"use client";
import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import HeadingSection from "../others/HeadingSection";
import Icon from "@/components/icons/Icons";

type FaqItem = {
  question: string;
  answer: string;
};

type FaqProps = {
  items: FaqItem[];
  subHeading?: string;
};

// Use \n for the next line in FAQ
export default function FaqSection({ items, subHeading }: FaqProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const handleToggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="max-w-5xl mx-auto sm:p-4">
      <HeadingSection
        heading="Frequently Asked Questions"
        subHeading={subHeading ?? "Get clear answers on everything about digital gold investing."}
      />

      <div className="space-y-3.5 sm:space-y-5">
        {items.map(({ question, answer }, index) => {
          const isActive = openIndex === index;

          return (
            <div
              key={index}
              className={`border-2 rounded-xl px-4 sm:px-7 overflow-hidden transition-colors duration-300 ${isActive ? "bg-[#1A1A1A] border-[#E0E0E0]" : "bg-transparent border-[#858585] hover:border-[#bebebe] hover:bg-[#363636]"}`}
            >
              <button
                onClick={() => handleToggle(index)}
                className="w-full flex justify-between items-center py-2.5 sm:py-5 text-sm xs:text-base md:text-lg font-medium text-white text-left"
              >
                {question}
                <Icon.expandableIcon isOpen={isActive} />
              </button>

              <AnimatePresence initial={false}>
                {isActive && (
                  <motion.div
                    key="content"
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3, ease: "easeInOut" }}
                    className="overflow-hidden"
                  >
                    <div className="text-white text-xs xs:text-sm md:text-base font-normal pb-3 sm:pb-4 pt-0">
                      <div
                        className="prose faq-content-dark-theme text-white text-xs xs:text-sm md:text-base font-normal pb-3 sm:pb-4 pt-0"
                        dangerouslySetInnerHTML={{ __html: answer }}
                      />
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          );
        })}
      </div>
    </div>
  );
}
